import * as moment from 'moment';

export class MissingPlayer {
    id: number;
    begin: moment.Moment;
    end: moment.Moment;
    type: string;
    playerId: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/missing-player.model.ts